// config.ts

export type Branch = {
    value: string;
    label: string;
  };
  
  export const branches: Branch[] = [
    { value: 'Brea', label: 'HQ, Brea, CA' },
    { value: 'Hayward', label: 'Hayward, CA' },
    { value: 'Dallas', label: 'Dallas, TX' },
    { value: 'Houston', label: 'Houston, TX' },
    { value: 'Washington', label: 'Kent, WA' },
    { value: 'Colorado', label: 'Aurora, CO' },
    { value: 'Florida', label: 'Tampa, FL' },
    { value: 'Illinois', label: 'Homer Glen, IL' },
    { value: 'Georgia', label: 'Doraville, GA' },
    { value: 'New Jersey', label: 'Fairfield, NJ' },
    { value: 'Massachusetts', label: 'Westborough, MA' },
    { value: 'Ohio', label: 'Groveport, OH' },
    { value: 'Vancouver', label: 'West Canada' },
    { value: 'Toronto', label: 'East Canada' },
    { value: 'Puerto Rico', label: 'Puerto Rico' },
    { value: 'Hawaii', label: 'Hawaii' },
  ];
  